import type { ApiClient } from '../client'
import type {
  CreateWorkflowRuleRequest,
  ListWorkflowRulesQuery,
  RuleTypesResponse,
  UpdateWorkflowRuleRequest,
  WorkflowRule,
} from '../types'

/** src/modules/workflow-rules/controllers/workflow-rules.controller.ts — no delete route exists. */
export function workflowRulesEndpoints(api: ApiClient) {
  return {
    list: (query: ListWorkflowRulesQuery = {}) =>
      api.get<readonly WorkflowRule[]>('workflow-rules', { query: { ...query } }),
    ruleTypes: () => api.get<RuleTypesResponse>('workflow-rules/rule-types'),
    get: (id: string) => api.get<WorkflowRule>(`workflow-rules/${id}`),
    create: (body: CreateWorkflowRuleRequest) => api.post<WorkflowRule>('workflow-rules', body),
    update: (id: string, body: UpdateWorkflowRuleRequest) =>
      api.patch<WorkflowRule>(`workflow-rules/${id}`, body),
  }
}
